import { actions } from './';

const initialState = () => {
    return {
        items: [],
        isBusy: false,
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.FETCH_UPSELL: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.FETCH_UPSELL_SUCCESS: {
            const items = [action.value];
            return {
                ...state,
                isBusy: false,
                error: null,
                items
            };
        }

        case actions.FETCH_UPSELL_FAILURE: {
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        }

        default:
            return state;
    }
}
